(function(){
  if (window.__ntReveal) return; window.__ntReveal = true;
  document.documentElement.classList.add('nt-js');
  function run(){
    var nodes = [].slice.call(document.querySelectorAll('[data-nt-reveal]:not(.nt-in)'));
    var showAll = function(){ nodes.forEach(function(n){ n.classList.add('nt-in'); }); };
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { showAll(); return; }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('nt-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(function(n){ io.observe(n); });
    setTimeout(showAll, 1500);
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
